import React, { useEffect } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import IntroPage from "../pages/IntroPage";
import SubscriptionPage from "../pages/SubscriptionPage";
import LoginPage from "../pages/LoginPage";
import OtpPage from "../pages/OtpPage";
import AuthPage from "../pages/AuthPage";
import SetAgePage from "../pages/SetAgePage";
import LilOnesPage from "../pages/LilOnesPage";
import CategoryPage from "../pages/CategoryPage";
import LoadingPage from "../pages/LoadingPage";
import ProfilePage from "../pages/ProfilePage";
import Auth from "../auth/Auth";
import MenuPage from "../pages/MenuPage";
import ErrorBoundary from "../pages/ErrorBoundary";
import Portal from "../pages/Portal";
import Profile from "../pages/Profile";
import ChooseAvatar from "../pages/ChooseAvatar";
import HowItWorks from "../pages/HowItWorks";
import Terms from "../pages/Terms";
import Unsubscribe from "../pages/Unsubscribe";
import Onboarding from "../pages/DesktopOnboarding";
import DesktopHome from "../pages/DesktopView/DesktopHome";
import DesktopLanding from "../pages/DesktopView/DesktopLanding";
import TermsPage from "../pages/TermsAndConditions";


const Routing = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <IntroPage/>,
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/loading",
      element: <LoadingPage />,
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/subscribe",
      element: <SubscriptionPage />,
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/login",
      element: <LoginPage />,
     
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/otp",
      element: <OtpPage />,
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/auth",
      element: (
        <Auth>
          <AuthPage/>
         </Auth> 
      ),
      errorElement: <ErrorBoundary />,
    },
      {
      path: "/profile",
      element: (
         <Auth>
          <Profile/>
          </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/termsandconditions",
      element: <TermsPage/>,
      errorElement: <ErrorBoundary />,
    },
       {
      path: "/avatar",
      element: (
         <Auth>
          <ChooseAvatar/>
         </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
      {
      path: "/howitworks",
      element: (
         <Auth>
          <HowItWorks/>
           </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/terms",
      element: (
        <Auth>
          <Terms/>
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
       {
      path: "/unsubscribe",
      element: (
          <Auth>
          <Unsubscribe/>
          </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/setAge",
      element: (
        <Auth>
          <SetAgePage />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/LilOnes",
      element: (
        <Auth>
          <LilOnesPage />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/LilOnes_English",
      element: (
        <Auth>
          <CategoryPage />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/profile1",
      element: (
        <Auth>
          <ProfilePage />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    
    {
      path: "/menu",
      element: (
        <Auth>
          <MenuPage />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path:"/portal",
      element:<Portal/>,
      errorElement: <ErrorBoundary />,
    },
    
  ]);
  return <RouterProvider router={router} />;
};

export default Routing;
